const supportSettings = {
  andrea: {
    imageSM: '/images/support/andrea-sm.jpg',
    firstName: 'Andrea',
    name: 'Andrea Gandica',
    position: 'Agent & Producer',
    email: 'andrea@swipecast.com',
    phoneNumber: '+16469609833',
    phoneLabel: '(646) 960-9833'
  },
  paola: {
    imageSM: '/images/support/paola-sm.jpg',
    firstName: 'Paola',
    name: 'Paola Polanca',
    position: 'Agent & Producer',
    email: 'paola@swipecast.com',
    phoneNumber: '+16466016429',
    phoneLabel: '(646) 601-6429'
  },
  email: 'support@swipecast.com',
  infoEmail: 'info@swipecast.com',
  whatsappURL: 'https://wa.me/16463276312',
  whatsappNumber: '+16463276312',
  whatsappLabel: '(646) 327-6312'
}

export default supportSettings
